function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Pagination from '../../pagination';
import { isFunction } from '../utils';
export default {
  methods: {
    getCurrent: function getCurrent() {
      var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

      // total > current*pageSize-pageSize, current才是有效的
      if ((current - 1) * pageSize > total) {
        return Math.floor((total - 1) / pageSize) + 1;
      }

      return current;
    },
    setInnerPager: function setInnerPager(pager) {
      this.innerPager = pager;
    },
    handlePagerChange: function handlePagerChange(current, pageSize) {
      var pagination = this.pagination,
          setInnerPager = this.setInnerPager,
          onPagerOrFiterOrSortChange = this.onPagerOrFiterOrSortChange;

      var pager = _objectSpread({}, this.innerPager, {
        current: current,
        pageSize: pageSize
      }); // 表示不能理解，这块估计是把antdesign的属性和uxcool的属性记混了才写出来的


      if (isFunction(pagination.onChange)) {
        pagination.onChange(current, pageSize);
      }

      setInnerPager(pager);
      onPagerOrFiterOrSortChange();
    },
    initPager: function initPager() {
      var normalizeData = this.normalizeData,
          size = this.size,
          innerPager = this.innerPager,
          pagination = this.pagination,
          getCurrent = this.getCurrent,
          handlePagerChange = this.handlePagerChange,
          setInnerPager = this.setInnerPager;
      var pager = {
        size: size !== 'default' ? 'small' : '',
        total: normalizeData.length,
        current: 1,
        pageSize: 10,
        position: 'bottom'
      };
      pager = _objectSpread({}, pager, {}, innerPager);

      if (typeof pagination !== 'boolean') {
        pager = _objectSpread({}, pager, {}, pagination);
      }

      pager.current = getCurrent(pager.current, pager.total, pager.pageSize);
      /**
       * http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/185
       * 添加pageSizeChange监听
       * */

      pager.on = {
        change: handlePagerChange,
        'page-size-change': handlePagerChange
      };
      setInnerPager(pager);
    },
    renderPagination: function renderPagination(pagerPosition) {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          theme = this.theme,
          hasPagination = this.hasPagination,
          innerPager = this.innerPager;

      if (!hasPagination) {
        return null;
      }

      var position = innerPager.position,
          className = innerPager.className,
          style = innerPager.style,
          on = innerPager.on,
          props = _objectWithoutProperties(innerPager, ["position", "className", "style", "on"]);

      return props.total > 0 && (position === pagerPosition || position === 'both') ? h(Pagination, {
        "class": ["".concat(prefixCls, "-pagination"), className],
        "style": style,
        "attrs": {
          "theme": theme
        },
        "props": _objectSpread({}, props),
        "on": _objectSpread({}, on)
      }) : null;
    }
  }
};